<div class="snack-bar-content">
  <div class="header">
    <div class="icon-container">
      @if (data.type=='success') {
        <mat-icon> done_outline </mat-icon>
      }
      @if (data.type=='error') {
        <mat-icon> error_outline </mat-icon>
      }
      @if (data.type=='warn') {
        <mat-icon> notifications </mat-icon>
      }
    </div>
    <span class="title">{{data.title}}</span>
    <button mat-icon-button class="close-button" (click)="closeSnackbar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="information">

    {{ data.message }}
  </p>
</div>